<template>
  <wb-slider show-dot-navigation show-arrow-navigation>
    <product-tile
      v-for="(item, index) in props.vehicles"
      :key="item.code"
      :product="item"
      :index="index"
      class="wb-slider__item tile"
    />
  </wb-slider>
</template>

<script lang="ts">
export default { name: 'HorizontalSlider' };
</script>

<script lang="ts" setup>
import { PropType } from 'vue';
import Vehicle from '@dh-io-emh/shared/src/models/vehicle.model';
import ProductTile from '../../productTile/index.vue';

const props = defineProps({
  vehicles: {
    type: Array as PropType<Vehicle[]>,
    default: () => [],
  },
});
</script>

<style lang="scss">
.tile:not(:last-child) {
  @include wb-spacing('margin-right', s);
}
</style>
